import {
  WSElementProps,
  WSField,
  WSFlexBox,
  WSIcon,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { queriesInstitutions } from "@query";
import { validatorRoutingNumber } from "../../validators/validatorRoutingNumber";

type Props = {
  routingNumberFieldName: string;
  rtpRequired?: boolean;
} & WSElementProps;

export const InstitutionPreview: React.FC<Props> = ({
  routingNumberFieldName,
  rtpRequired,
  ...props
}) => {
  const { watch } = useFormContext();

  const routingNumberFieldValue = watch(routingNumberFieldName);

  const isValidRoutingNumber = useMemo(() => {
    return (
      routingNumberFieldValue &&
      validatorRoutingNumber.isValidSync(routingNumberFieldValue)
    );
  }, [routingNumberFieldValue]);

  const queryInstitution = queriesInstitutions.getInstitution.useQuery(
    { routingNumber: routingNumberFieldValue },
    { enabled: !!isValidRoutingNumber, retry: false }
  );

  if (!isValidRoutingNumber) {
    return null;
  }

  if (queryInstitution.isError) {
    return (
      <WSField
        mt="S"
        message="We couldn't find a bank with this routing number."
        status="warning"
        {...props}
      />
    );
  }

  if (queryInstitution.data) {
    if (rtpRequired && !queryInstitution.data.isRTPSupported) {
      return (
        <WSField
          mt="S"
          message="This bank does not support instant payments"
          status="warning"
          {...props}
        />
      );
    }

    return (
      <WSFlexBox.CenterY mt="S" {...props}>
        <WSIcon block name="check" size="S" color="green500" mr="XS" />
        <WSText.ParagraphSm weight="medium" color="gray500">
          {queryInstitution.data.name}
        </WSText.ParagraphSm>
      </WSFlexBox.CenterY>
    );
  }

  return null;
};
